import React from "react";
import { Loupe } from "../../../assets/img/loupe";
import { MarketplaceFilterSearchWrapper, MarketplaceFilterSearchInput, MarketplaceFilterSearchLogo } from "./MarketplaceFilter.styled";

export const MarketplaceFilterSearch = () => {
  return (
    <MarketplaceFilterSearchWrapper>
      <MarketplaceFilterSearchInput placeholder='Collections, items or user..' />
      <MarketplaceFilterSearchLogo>{Loupe()}</MarketplaceFilterSearchLogo>
    </MarketplaceFilterSearchWrapper>
  );
};
